import { render, staticRenderFns } from "./masterBank.vue?vue&type=template&id=416b5bb7&scoped=true"
import script from "./masterBank.vue?vue&type=script&lang=js"
export * from "./masterBank.vue?vue&type=script&lang=js"
import style0 from "./masterBank.vue?vue&type=style&index=0&id=416b5bb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b5bb7",
  null
  
)

export default component.exports